import _ from "lodash";

import NoPrint from "components/NoPrint";
import Stack from "components/Stack";

import MemoSectionContextButton from "entities/Memo/components/Sections/ContextButton";
import NASection from "entities/Memo/components/Sections/NASection";
import NoProformaUploaded from "entities/Memo/components/Sections/NoProformaUploaded";
import SectionSummary from "entities/Memo/components/Sections/Summary";
import { IMemoSection } from "entities/Memo/sdk";
import { useRentalDataManager } from "entities/Memo/utils";
import ProformaFloorArea from "entities/Proforma/components/ProformaFloorArea";

interface ISectionFloorArea {
  dealId: number;
  externalToken?: string;
  section?: IMemoSection;
  onUpdate?: () => void;
}

const SectionFloorArea: React.FC<ISectionFloorArea> = ({
  dealId,
  externalToken,
  section,
  onUpdate,
}) => {
  const { data: rentalIncomeData } = useRentalDataManager({
    token: externalToken,
    dealId,
  });

  return (
    <>
      {rentalIncomeData &&
      !_.isEmpty(rentalIncomeData.rental_data.unit_type_and_floor_area) ? (
        <Stack spacing={2} data-testid="floor-area-section">
          {section && _.isUndefined(externalToken) && (
            <NoPrint
              sx={{
                alignSelf: "flex-end",
              }}
            >
              <MemoSectionContextButton
                dealId={dealId}
                section={section}
                onUpdate={onUpdate}
              />
            </NoPrint>
          )}
          {section?.is_na ? (
            <NASection />
          ) : (
            <Stack justifyContent="space-between" spacing={4}>
              <ProformaFloorArea rentalIncomeData={rentalIncomeData} />
              <SectionSummary
                title="Floor Area description"
                category="Floor Area Descriptions"
                dealId={dealId}
                externalToken={externalToken}
              />
            </Stack>
          )}
        </Stack>
      ) : (
        <NoProformaUploaded title="Floor Area" />
      )}
    </>
  );
};

export default SectionFloorArea;
